import React, { useEffect , useState} from "react";
import { SuggestionsProps, useSearch, useResults } from "@usereactify/search";

export type InstantSearchSuggestions = React.ComponentProps<NonNullable<SuggestionsProps["render"]>>;
export const InstantSearchSuggestions: React.FC<InstantSearchSuggestions> = (
  props
) => {

  const { setSearchTerm } = useSearch();
  const [ suggestionTitle, setSuggestionTitle] = useState(""); 
  const [ suggestions, setSuggestions] = useState([{}]); 

  useEffect(() => {
    if(props?.suggestions?.length) {
      setSuggestionTitle("Suggestions");
      setSuggestions(props.suggestions.length > 4 ? props.suggestions.slice(0,4) : props.suggestions);
    }
    else {
      try {
        let newTerms = [] as any
        const shopSettings = JSON.parse(document.querySelector("#shopify-setting-data")?.innerHTML as string);
        const terms = shopSettings?.search_popular_search?.split('|');
  
        terms.map((term:string) => {
          newTerms.push({"text": term});
        })
  
        setSuggestions(newTerms);
        setSuggestionTitle("popular search terms");
      }
      catch{}
    }
  }, [props])

  
  const onTermSubmit = (term: any) => {
    const termText = term.text ? term.text : term;
    const input = document.querySelector(".instant-search__form input") as HTMLInputElement;

    input.value = termText; 
    setSearchTerm(termText)
  }

  return (
    <>
      <h3>{suggestionTitle}</h3>
      <ul>
        {
          suggestions.length ? 
          suggestions?.map((term: any) => (
            <li onClick={() => onTermSubmit(term)}>
              {term.text}
            </li>
          ))
          :
          null
        }
      </ul>
    </>
  );
};
